import { layoutRenderers } from './layouts';
import { complexRenderers } from './complex';
import { controlRenderers } from './controls';

export const quasarRenderers = [...layoutRenderers, ...complexRenderers, ...controlRenderers];
